"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getIndexAfter(value, startIndex, find) {
    for (let i = startIndex + 1; i < value.length; i++) {
        if (find(value[i])) {
            return i;
        }
    }
    return null;
}
exports.default = getIndexAfter;
//# sourceMappingURL=getIndexAfter.js.map